<template>
  <div>
    <datatable
      title="Admin Education Courses"
      @delete="deleteEducationCourse"
      @create="createEducationCourse"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-education-courses',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'name',
          value: 'name'
        }
      ],
      data: [],
      operations: []
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAllEducationCourses().then(response => {
        this.data = response
      })
    },
    deleteEducationCourse (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.name,
        item_name: delete_data.name,
        method: 'deleteEducationCourse',
        method_params: { id: delete_data.id }
      })
    },
    createEducationCourse () {
      this.create({ designator: 'admin-education-course-form-modal', component_name: 'AdminEducationCoursesForm', is_create: true, modal_title: 'Create new Education Course' })
    },
    editClick (data) {
      this.create({ designator: 'admin-education-course-form-modal', component_name: 'AdminEducationCoursesForm', data, modal_title: data.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
